module.exports = __webpack_public_path__ + "img/complete.7a90c664.svg";